interface AuthModel {
    email: string;
    password: string;
    error: string;
}

interface DefinePasswordModel {
    token: string;
    mail: string;
    password: string;
}

interface ErrorViewModel {
    requestId: string;
    showRequestId: boolean;
}

interface ResetPasswordModel {
    mail: string;
}

interface FormulaireNutritionModel {
    Id: string;
    Poids: number;
    Protocole: TypeProtocole;
    Sport: TypeSport;
    DureeSuperieure90Minutes: boolean;
    Repas: FormulaireNutrition_RepasModel[];
    AucunAntecedentMedicauxConfirme: boolean;
    CgvCguAcceptees: boolean;
    DejaFaitUneSurcharge: boolean;
    Course40kmSemaineMini: boolean | null;
    ChoixPerformance: boolean | null;
    GrammesSurcharge: number;
    DateCourse: string | null;
    HeureSeanceActivation: string | null;
    HeureDepartCourse: string | null;
    HoraireAvantCourse: FormulaireHoraireAvantCourse[];
    RestrictionGlucides: string | null;
    PlanNiveauPrecision: PlanNiveauPrecision | null;
    AutresInformations: string | null;
    Email: string | null;
    EndFormulaire: boolean;
    MailEnvoye: boolean;
    AjouterProduitsProposesAuPanier: boolean;
}

interface FormulaireHoraireAvantCourse {
    TypeJour: TypeJourAvantCourse;
    HeureReveil: string;
    HeureDejeuner: string;
    HeureDiner: string;
    HeureCoucher: string;
}

interface FormulaireNutrition_RepasModel {
    Id: string | null;
    CodeRepasPropose: string;
    TypeAppetit: TypeAppetit;
    AjustementPersonnalise: boolean;
    TypeRepas: TypeRepas;
    Ingredients: FormulaireNutrition_Repas_IngredientModel[];
}

interface FormulaireNutrition_Repas_IngredientModel {
    Id: string | null;
    CodeIngredient: string;
    QuantiteGrammes: number;
}

interface PropositionRepas {
    TypeRepas: TypeRepas;
    Repas: PropositionRepas_Repas[];
}

interface PropositionRepas_Repas {
    Name: string;
    Img: string;
    Code: string;
    Ingredients: string;
    Composition: PropositionRepas_Repas_Composant[];
    Appetits: [TypeAppetit: string]
    PropositionAjoutCompos: PropositionRepas_Repas_Composant[];
}

interface PropositionRepas_Repas_Composant {
    PoidsGrammes: number
    Code: number;
}

interface AlimentProposee {
    Code: string;
    Nom: string;
    Quantité: number;
    GlucidesPour100g: number;
}

interface PrisePoudreAmont {
    Jour: TypeJourAvantCourse;
    Minutes: number;
    Grammes: number;
}

interface CalculateurResultat {
    DeficitGrammes: number;
    RepasGrammes: number;
    AmontGrammes: number;   // calculé côté serveur, reçu tel quel
    Cible: number;
    SeuilDeclenche: boolean;
    PrisesAmont: PrisePoudreAmont[];
    AugmentationEncas: number;
    AugmentationRepas: number;
}

enum TypeAppetit {
    Faible = 1,
    Moyen = 2,
    Fort = 3,
}

enum TypeSport {
    CourseAPied = 0,
    Velo = 1,
    Triathlon = 2
}

enum TypeProtocole {
    TroisJours = 0,
    DeuxJours = 1
}

enum TypeRepas {
    PetitDejeuner,
    Dejeuner,
    Diner,
    Encas
}

enum PlanNiveauPrecision {
    Detaille,
    Souple,
}

enum TypeJourAvantCourse {
    JMoins1 = 0,
    JMoins2 = 1,
    JMoins3 = 2
}
